import PropTypes from "prop-types"; // Add this import

import React, { useEffect, useRef, useState } from "react";
import "./MigrationAddDialog.scss";
import {
  DialogTitle,
  DialogActions,
  DialogContent,
  Button,
  Autocomplete,
  TextField,
  Chip,
} from "@mui/material";

import { notify } from "../../utils/services/notification";
import { createMigration } from "../../utils/services/lighthouse";

const migrateCids = async (setCreateMigrate: any, cids: string[]) => {
  try {
    //
    const arrObj: any = [];
    cids.forEach((cid) => arrObj.push({ cid: cid }));
    const response = await createMigration(arrObj);
    response["status"] === 200 &&
      notify(`Request ID : ${response?.["data"]?.["requestID"]}`, "success");
    setCreateMigrate(false);
  } catch (error) {
    notify(`${error}`, "error");
  }
};

const MigrationAddDialog: React.FC<{
  setCreateMigrate: any;
}> = ({ setCreateMigrate }) => {
  const [cids, setCids] = useState<string[]>([]);
  const ref = useRef<any>();

  useEffect(() => {
    let componentMounted = true;

    const handlePasteAnywhere = (event: ClipboardEvent) => {
      const existingCids: string[] = ref?.current?.props?.value || [];
      const pasteContent = event?.clipboardData?.getData("text");
      const refinedPasteContent = pasteContent?.replace(/\s/g, "");
      const cidArr = refinedPasteContent?.split(",");
      cidArr?.pop();

      if (existingCids?.length > 0) {
        if (componentMounted) {
          setCids([...(existingCids ?? []), ...(cidArr ?? [])]);
        }
      } else {
        if (componentMounted) {
          setCids(cidArr ?? []);
        }
      }
    };

    window.addEventListener("paste", handlePasteAnywhere as EventListener);
    return () => {
      window.removeEventListener("paste", handlePasteAnywhere as EventListener);
      componentMounted = false;
    };
  }, []);

  const uploadFile = () => {
    document.getElementById("csv_file")?.click();
  };

  const getEventFile = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const files = event.target.files;
    let unProcessedArray: any[] = [];
    const processedArray: string[] = [];
    if (files) {
      import('papaparse').then(Papa =>{
        Papa.parse(files[0], {
          complete: function (results) {
            unProcessedArray = results.data;
            if (unProcessedArray.length > 0) {
              unProcessedArray.forEach((item: any) => {
                item?.[0]?.length > 0 && processedArray.push(item[0]);
              });
            }
            setCids(processedArray);
          },
        });
      })
    }
  };

  return (
    <>
      <DialogTitle>{"Migrate Files"}</DialogTitle>
      <DialogContent>
        <p>
          Enter CID's you want to migrate or &nbsp;
          <span
            className="link"
            onClick={() => {
              uploadFile();
            }}
          >
            upload the csv file
          </span>{" "}
          &nbsp; with the cids
        </p>

        <div className="inputBox">
          <Autocomplete
            multiple
            id="tags-filled"
            options={[]}
            onChange={(event: any, newValue: any) => {
              setCids(newValue);
            }}
            value={cids}
            freeSolo
            renderTags={(value: readonly string[], getTagProps: any) =>
              value.map((option: string, index: number) => {
                const { key, ...tagProps } = getTagProps({ index });
                return (
                  <Chip
                    variant="outlined"
                    label={option}
                    key={key}
                    {...tagProps}
                  />
                );
              })
            }
            renderInput={(params: any) => (
              <TextField
                {...params}
                variant="standard"
                label="CIDs"
                placeholder="Add CIDs Here"
              />
            )}
          />

<p>
          <small>Note: You can include up to 10,000 CIDs in a single migration request.</small>
        </p>
        </div>

        <a href={"/cids_CSV.csv"} className="link" download="SampleCSV.csv">
          {" "}
          Download Sample CSV
        </a>

        <input
          type="file"
          accept=".csv"
          id="csv_file"
          onChange={(e) => getEventFile(e)}
          hidden
        />
      </DialogContent>
      <DialogActions style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          disabled={cids.length === 0}
          onClick={() => {
            migrateCids(setCreateMigrate, cids);
          }}
        >{`Migrate`}</Button>
      </DialogActions>
    </>
  );
};

MigrationAddDialog.propTypes = {
  setCreateMigrate: PropTypes.func.isRequired,
};

export default MigrationAddDialog;
